'use strict';

import angular from 'angular';
import StudentsController from './students.controller';

export default angular.module('accessApp.students', ['accessApp.auth', 'ui.router'])
  .config(function($stateProvider) {
  'ngInject';

  $stateProvider.state('students', {
    url: '/students',
    template: require('./students.html'),
    controller: 'StudentsController',
    controllerAs: 'vm',
  });
})
  .controller('StudentsController', StudentsController)
  .name;





// WEBPACK FOOTER //
// ./client/app/students/index.js